module.exports = __webpack_public_path__ + "static/media/social-mark.6284c9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-mark.png
// module id = 363
// module chunks = 0